import React from "react";
import { RefreshCw } from "lucide-react";

interface SimpleOfflineModalProps {
  isOpen: boolean;
  onClose: () => void;
  onRetry?: () => void;
  isRetrying?: boolean;
}

const SimpleOfflineModal: React.FC<SimpleOfflineModalProps> = ({
  isOpen,
  onClose,
  onRetry,
  isRetrying = false,
}) => {
  if (!isOpen) return null;

  const handleRetry = () => {
    if (onRetry) {
      onRetry();
    }
  };

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/30 backdrop-blur-sm">
      <div className="flex flex-col items-center justify-center">
        {/* Circular Preloader */}
        <div className="relative">
          <div className="h-16 w-16 animate-spin rounded-full border-4 border-gray-300 border-t-red-500"></div>
          <div className="absolute inset-0 flex items-center justify-center">
            <RefreshCw className="h-6 w-6 text-red-500" />
          </div>
        </div>

        {/* Simple Text */}
        <p className="mt-4 text-white text-sm font-medium">
          {isRetrying ? "Mencoba menghubungkan..." : "Koneksi terputus"}
        </p>

        {/* Retry Button (Optional) */}
        {!isRetrying && (
          <button
            onClick={handleRetry}
            className="mt-3 px-4 py-2 bg-red-500 text-white text-sm rounded-lg hover:bg-red-600 transition-colors"
          >
            Coba Lagi
          </button>
        )}
      </div>
    </div>
  );
};

export default SimpleOfflineModal;
